import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {
    HardwareErrorsResponse
} from '../types/hardwareErrors';
import { RootState } from '../store';

export const hardwareErrorsApi = createApi({
    reducerPath: 'hardwareErrorsApi',
    baseQuery: fetchBaseQuery({
        baseUrl: `${process.env.PUBLIC_URL}/api/HardwareErrors`,
        prepareHeaders: (headers, { getState }) => {
            const accessToken = (getState() as RootState).userStateReducer.accessToken;
            if (accessToken !== '') {
                headers.set('authorization', `Bearer ${accessToken}`);
            }
            return headers;
        }
    }),
    endpoints: (builder) => ({
        getErrorsBySerialNumber: builder.query<HardwareErrorsResponse, {
            serialNumber: string;
            severity?: string[];
        }>({
            query: ({ serialNumber, severity }) => {
                const params = new URLSearchParams({
                    serialNumber
                });
                if (severity) params.append('severity', severity.join(','));

                return `/GetBySerialNumber?${params.toString()}`;
            }
        })
    })
});

// Map errorsData.errors to ErrorTimelinePoint array

export const {
    useGetErrorsBySerialNumberQuery
} = hardwareErrorsApi;
